import apiFetch from '../apiFetch'

export default function (idTipoDosis, token) {
  return apiFetch({endPoint: `TipoDosis/cambiarTipoDosisPredeterminado`, method: 'POST', body: {idTipoDosis}, token: token})
}